import styled from 'styled-components'

export const CommonBlogPageBodyWrapperUi = styled.div`
  position: relative;
`
